import { render, staticRenderFns } from "./ProductAddIframe.vue?vue&type=template&id=690f7c5a&"
import script from "./ProductAddIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductAddIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports